import { market } from '../constants';

export const customizeTrackingMessage = () => market === 'pe';

export const defineErrorMessage = (dispatch) => {
  if (dispatch.error) {
    switch (dispatch.error.id) {
      case 'REFUND-01':
        return 'Solicitamos el reembolso a la entidad bancaria correspondiente.';
      case 'REFUND-02':
        return 'Lo sentimos, tuvimos un inconveniente con tu pedido y estamos tramitando tu reembolso. Agradecemos tu preferencia.';
      case 'PICK_UP':
        return 'Lo sentimos, tuvimos un inconveniente entregando tu pedido. Recuerda que tienes 7 días para realizar el retiro.';
      case 'NO_STOCK':
        return 'Lo sentimos, tuvimos inconvenientes para validar el stock necesario para atender tu pedido. Lamentamos el inconveniente y agradecemos tu preferencia.';
      case 'CONTACT':
        return 'Lo sentimos, tuvimos un inconveniente entregando tu pedido. Si necesitas contactarnos llama al (01) 611-5959. Estamos a tu disposición para atender cualquier duda.';
      case 'ISSUE':
        return 'Lo sentimos, tuvimos un inconveniente con tu pedido. Estamos revisando el problema, agradecemos tu preferencia.';
      default:
        return '';
    }
  }
  return '';
};
